import React from 'react';

const CheckedBoxIcon = ({
    width = 24,
    height = 24,
    boxFillColor = "#4318FF",
    tickStrokeColor = "white",
    tickStrokeWidth = "2",
    className = ""
}) => {
    // Using the specific clipPath ID from the provided SVG
    const clipPathId = "clip0_15660_122971";

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="3" y="3" width="18" height="18" rx="2" fill={boxFillColor} />
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d="M18 8.25L9.75 16.5L6 12.75"
                    stroke={tickStrokeColor}
                    strokeWidth={tickStrokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CheckedBoxIcon;